const paramsScore = {
    photoURL: 20,
    name: 15,
    borndate: 10,
    gender: 5,
    phone: 10,
    country: 5,
    city: 5,
    company: 10,
    study: 10,
    interests: 10
}, defaultPhotos = [
    "https://visualpharm.com/assets/996/Edit%20User%20Male-595b40b65ba036ed117d10dd.svg",
    "https://visualpharm.com/assets/386/Female Profile-595b40b65ba036ed117d3de0.svg",
    "https://visualpharm.com/assets/319/Male User-595b40b65ba036ed117d3de6.svg",
    "https://visualpharm.com/assets/514/Lamp Of Alladin-595b40b75ba036ed117d852c.svg"
];

let 
    score = 0,
    pending = [];

export default class ProfileUtil{
    constructor(data){
        for (var index in data){
            this[index] = data[index];
        }
        this.package = data.package || "";
        this.package_id = data.package_id || "";
        this.sa = (data.sa === undefined ? false : (data.sa === data.uid ? data.sa : false));
        this.terms = (data.terms === undefined ? false : data.terms);
        this.packageDetails = {};

        this.setScore(data);
    }

    update = (values) =>{
        for (var obj in values){
            this[obj] = values[obj];
        }
        this.setScore();
    }
    
    getPending = () => { return pending }

    getScore = () => { return score }
    
    setScore = () => {
        score = 0;
        pending = [];
        for (var obj in this) {
            if (paramsScore[obj] !== undefined && this[obj] !== undefined && this[obj] !== "") {
                score += paramsScore[obj];
            } 
            if (this[obj] === undefined){
                pending.push(obj);
            }
        }
        
        if (defaultPhotos.indexOf(this.photoURL) >= 0){
            score -= paramsScore.photoURL;
            pending.push("photoURL");
        }
        
        /*if (this.name.first !== undefined && this.name.first === "") {
            score -= paramsScore.name;
            pending.push("name");
        }*/

        return true;
    }

    setPackageData(data){
        this.packageDetails = data;
    }
}